import { createApp } from 'vue'
import App from './App.vue'
//import './registerServiceWorker'
import router from './router'
import { BootstrapVue3 } from 'bootstrap-vue-3'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css'
import axios from 'axios'

import { BFormInput } from 'bootstrap-vue-3'
export default {
  components: {
    BFormInput
  }
}
import '@fortawesome/fontawesome-free/css/all.css'

const app = createApp(App)

export const BASE_URL = `${window.location.protocol}//${window.location.host}/`;
export const API_URL = BASE_URL+'api/'
export const MEDIA_URL = BASE_URL+'media/'
export const FILES_URL = BASE_URL+'media/'

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';
axios.defaults.withCredentials = true

export const axiosInstance = axios.create()
axiosInstance.interceptors.request.use(config => {

  // Dynamically update headers from localStorage
  config.headers['User-ID'] = localStorage.getItem("User_id")
  config.headers['token'] = localStorage.getItem("Token")
  //config.headers['Access-Control-Allow-Origin'] = '*'

  return config
}, error => {
  
  return Promise.reject(error)
})

axios.defaults.withCredentials = true
//axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

app.config.globalProperties.$axios = axios
app.config.compat = true
app.use(BootstrapVue3)
app.use(router)
app.mount("#app")


//createApp(App).use(router).mount('#app')
